import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pa-3 height-full" }

import { useFilterStore } from "@/store/filter";
import AssetLifecycleCostsChart from "@/components/metrics/AssetLifecycleCostsChart.vue";
import PM02PM03Chart from "@/components/metrics/PM02PM03Chart.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'metrics',
  setup(__props) {

const filters = useFilterStore();
filters.hide();

return (_ctx: any,_cache: any) => {
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_card, {
      class: "pa-3",
      variant: "outlined"
    }, {
      default: _withCtx(() => [
        _createVNode(AssetLifecycleCostsChart)
      ]),
      _: 1
    }),
    _createVNode(_component_v_card, {
      class: "pa-3 mt-4",
      variant: "outlined"
    }, {
      default: _withCtx(() => [
        _createVNode(PM02PM03Chart)
      ]),
      _: 1
    })
  ]))
}
}

})